import { computedFrom } from 'aurelia-binding';
import { EventAggregator } from 'aurelia-event-aggregator';
import {
	autoinject,
	BindingEngine,
	customElement,
	PLATFORM,
	useView,
} from 'aurelia-framework';
import { Form } from '~/components/form/form';
import { Field } from '../common/field';
import { convertInputMask } from '~/inputmasks/input-mask-converter';
import {
	commonFieldProperties,
	registerComponent,
} from '~/forms/customisation-editor/property-meta';

const componentTagName = 'a-abn';

registerComponent(componentTagName, {
	name: 'ABN/ACN',
	requirePath: PLATFORM.moduleName('components/field/custom/abn'),
	props: [...commonFieldProperties],
	isSelectable: true,
});

@autoinject
@customElement(componentTagName)
@useView(PLATFORM.moduleName('./abn.html'))
export class ABNField extends Field {
	constructor(
		public element: Element,
		protected parentForm: Form,
		readonly eventAggregator: EventAggregator,
		protected bindingEngine: BindingEngine,
	) {
		super(Field.TYPE.TEXT, element, parentForm, eventAggregator);
	}
	public attached() {
		super.attached();
		this.eventSubscriptions.push(
			this.bindingEngine
				.propertyObserver(this, 'displayValue')
				.subscribe(() => (this.placeholder = this.displayValue)),
		);
	}

	@computedFrom('fieldModel', 'fieldModel.inputMask')
	get inputmaskOptions(): inputmask.InputmaskOptions {
		// default input mask
		let mask = '99 999-999-999';
		if (this.fieldModel && this.fieldModel.inputMask) {
			mask = convertInputMask(this.fieldModel.inputMask);
		}
		return {
			autoUnmask: false,
			clearMaskOnLostFocus: true,
			placeholder: '0',
			clearIncomplete: false,
			mask,
		};
	}
}
